export class GlobalConstants {
    public static initial_mymee_program_cost_per_client : number = 2500;
}
